import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      setDeferredPrompt(null);
    }
  };

  if (!deferredPrompt || dismissed) return null;

  return (
    <div
      className="bg-gradient-to-r from-blue-900 to-blue-800 text-white rounded-xl p-4 flex items-center justify-between gap-4"
      data-testid="install-pwa-banner"
    >
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 bg-white/20 rounded-lg flex items-center justify-center shrink-0">
          <Download className="h-5 w-5" />
        </div>
        <div>
          <p className="font-semibold text-sm">Installer CiviquePrep</p>
          <p className="text-xs text-blue-200">
            Accédez rapidement depuis votre écran d'accueil
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button
          onClick={handleInstall}
          size="sm"
          className="bg-white text-blue-900 hover:bg-blue-50"
          data-testid="install-pwa-btn"
        >
          Installer
        </Button>
        <button
          onClick={() => setDismissed(true)}
          className="text-white/60 hover:text-white p-1"
          data-testid="dismiss-pwa-btn"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default InstallPWA;
